import { styled } from "@pigment-css/react";
import { hasTrend, TrendPercent } from "@acto/taskpane/field-sales-2/components/primitives/TrendPercent";
import { Label, Marker, Value, type KpiFigureContent } from "./KpiFigure";

const Figure = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: theme.fieldSalesTwo.spacing[4],
  minWidth: 0,
}));

const Row = styled("div")(({ theme }) => ({
  display: "flex",
  flexWrap: "wrap",
  columnGap: theme.fieldSalesTwo.spacing[8],
}));

const PreviousValue = styled("p")(({ theme }) => ({
  margin: 0,
  fontFamily: theme.fieldSalesTwo.font.family,
  fontSize: theme.fieldSalesTwo.font.size["24"],
  fontWeight: theme.fieldSalesTwo.font.weight["500"],
  lineHeight: theme.fieldSalesTwo.font.lineHeight["148"],
  letterSpacing: theme.fieldSalesTwo.font.letterSpacing.subtle,
  color: theme.fieldSalesTwo.colors.neutral[700],
  overflowWrap: "anywhere",
}));

export interface InlineKpiFigureProps extends KpiFigureContent {
  seriesColor: string;
}

export function InlineKpiFigure({ label, value, previousValue, trendPercent, seriesColor }: InlineKpiFigureProps) {
  return (
    <Figure>
      <Row>
        <Marker aria-hidden style={{ background: seriesColor }} />
        <Label>{label}</Label>
        {hasTrend(trendPercent) && <TrendPercent percent={trendPercent} size="label" />}
      </Row>
      <Row>
        <Value>{value}</Value>
        {previousValue !== undefined && <PreviousValue>{previousValue}</PreviousValue>}
      </Row>
    </Figure>
  );
}
